"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("@flowio/events");
var facebookPixel_1 = __importDefault(require("./fb/facebookPixel"));
var googleAnalytics_1 = __importDefault(require("./ga/googleAnalytics"));
var googleAnalyticsGtag_1 = __importDefault(require("./gtag/googleAnalyticsGtag"));
var snapPixel_1 = __importDefault(require("./snap/snapPixel"));
var gtm_1 = require("./gtm");
var ReadyState;
(function (ReadyState) {
    ReadyState["Complete"] = "complete";
    ReadyState["Loading"] = "loading";
})(ReadyState || (ReadyState = {}));
function groupTrackersByType(trackers) {
    var facebookTrackers = [];
    var snapchatTrackers = [];
    var googleAnalyticsTrackers = [];
    var globalSiteTagTrackers = [];
    var googleTagManagerTrackers = [];
    trackers.forEach(function (tracker) {
        switch (tracker.discriminator) {
            case 'facebook_pixel':
                facebookTrackers.push(tracker);
                break;
            case 'google_analytics':
                googleAnalyticsTrackers.push(tracker);
                break;
            case 'google_global_site_tag':
                globalSiteTagTrackers.push(tracker);
                break;
            case 'google_tag_manager':
                googleTagManagerTrackers.push(tracker);
                break;
            case 'snapchat_pixel':
                snapchatTrackers.push(tracker);
                break;
        }
    });
    return {
        facebookTrackers: facebookTrackers,
        snapchatTrackers: snapchatTrackers,
        googleAnalyticsTrackers: googleAnalyticsTrackers,
        globalSiteTagTrackers: globalSiteTagTrackers,
        googleTagManagerTrackers: googleTagManagerTrackers,
    };
}
var Pixel = /** @class */ (function () {
    function Pixel(options) {
        var _this = this;
        this.options = options || {};
        this.delayTotal = 0;
        this.delayMs = 0;
        this.delayStep = 1;
        this.readyState = ReadyState.Loading;
        this.setup(function () {
            if (_this.facebookPixelEnabled() && _this.facebookPixelReady()) {
                var facebookPixelOptions = __assign({}, _this.options.facebookPixelOptions);
                _this.fbPixel = new facebookPixel_1.default(facebookPixelOptions);
            }
            if (_this.gtagAnalyticsEnabled() && _this.gtagAnalyticsReady()) {
                var gtagAnalyticsOptions = __assign({}, _this.options.gtagAnalyticsOptions);
                _this.gtagPixel = new googleAnalyticsGtag_1.default(gtagAnalyticsOptions);
            }
            if (_this.googleAnalyticsEnabled() && _this.googleAnalyticsReady()) {
                var googleAnalyticsOptions = __assign({}, _this.options.googleAnalyticsOptions);
                _this.gaPixel = new googleAnalytics_1.default(googleAnalyticsOptions);
            }
            if (_this.snapchatAnalyticsEnabled() && _this.snapchatAnalyticsReady()) {
                var snapchatPixelOptions = __assign({}, _this.options.snapchatPixelOptions);
                _this.snapPixel = new snapPixel_1.default(snapchatPixelOptions);
            }
            if (_this.options.googleTagManagerOptions != null) {
                _this.gtmPixel = new gtm_1.GoogleTagManager(_this.options.googleTagManagerOptions);
            }
            if (_this.delayTotal > 0) {
                _this.ready();
            }
        });
    }
    Pixel.create = function (options) {
        var callback = options.callback, timeout = options.timeout, _a = options.trackers, trackers = _a === void 0 ? [] : _a, useBaseCurrency = options.useBaseCurrency;
        var _b = groupTrackersByType(trackers), facebookTrackers = _b.facebookTrackers, globalSiteTagTrackers = _b.globalSiteTagTrackers, googleAnalyticsTrackers = _b.googleAnalyticsTrackers, googleTagManagerTrackers = _b.googleTagManagerTrackers, snapchatTrackers = _b.snapchatTrackers;
        var legacyOptions = {
            callback: callback,
            timeout: timeout,
        };
        if (facebookTrackers.length > 0) {
            legacyOptions.facebookPixelOptions = {
                useBaseCurrency: useBaseCurrency,
            };
            facebookPixel_1.default.install({
                trackers: facebookTrackers,
            });
        }
        if (snapchatTrackers.length > 0) {
            legacyOptions.snapchatPixelOptions = {
                useBaseCurrency: useBaseCurrency,
            };
            snapPixel_1.default.install({
                trackers: snapchatTrackers,
            });
        }
        if (googleAnalyticsTrackers.length > 0) {
            legacyOptions.googleAnalyticsOptions = {
                useBaseCurrency: useBaseCurrency,
                trackers: googleAnalyticsTrackers,
            };
            googleAnalytics_1.default.install({
                trackers: googleAnalyticsTrackers,
            });
        }
        if (globalSiteTagTrackers.length > 0) {
            legacyOptions.gtagAnalyticsOptions = {
                useBaseCurrency: useBaseCurrency,
                trackers: globalSiteTagTrackers,
            };
            googleAnalyticsGtag_1.default.install({
                trackers: globalSiteTagTrackers,
            });
        }
        if (googleTagManagerTrackers.length > 0) {
            legacyOptions.googleTagManagerOptions = {
                useBaseCurrency: useBaseCurrency,
            };
            gtm_1.GoogleTagManager.install({
                trackers: googleTagManagerTrackers,
            });
        }
        return new Pixel(legacyOptions);
    };
    Pixel.prototype.ready = function () {
        this.readyState = ReadyState.Complete;
        var events = new events_1.ChannelEventEmitter();
        events.trigger('pixelReady');
        if (typeof this.options.callback === 'function') {
            this.options.callback();
        }
    };
    Pixel.prototype.facebookPixelEnabled = function () {
        return typeof this.options.facebookPixelOptions !== 'undefined';
    };
    Pixel.prototype.facebookPixelReady = function () {
        return facebookPixel_1.default.test(window);
    };
    Pixel.prototype.googleAnalyticsEnabled = function () {
        return typeof this.options.googleAnalyticsOptions !== 'undefined';
    };
    Pixel.prototype.googleAnalyticsReady = function () {
        return googleAnalytics_1.default.test(window);
    };
    Pixel.prototype.gtagAnalyticsEnabled = function () {
        return typeof this.options.gtagAnalyticsOptions !== 'undefined';
    };
    Pixel.prototype.gtagAnalyticsReady = function () {
        return googleAnalyticsGtag_1.default.test(window);
    };
    Pixel.prototype.snapchatAnalyticsEnabled = function () {
        return typeof this.options.snapchatPixelOptions !== 'undefined';
    };
    Pixel.prototype.snapchatAnalyticsReady = function () {
        return snapPixel_1.default.test(window);
    };
    Pixel.prototype.setup = function (callback) {
        var _this = this;
        this.backoff(function () {
            return _this.delayTotal > 0 &&
                (!_this.facebookPixelEnabled() || _this.facebookPixelReady()) &&
                (!_this.googleAnalyticsEnabled() || _this.googleAnalyticsReady()) &&
                (!_this.gtagAnalyticsEnabled() || _this.gtagAnalyticsReady()) &&
                (!_this.snapchatAnalyticsEnabled() || _this.snapchatAnalyticsReady());
        }, callback);
    };
    Pixel.prototype.backoff = function (test, callback) {
        var _this = this;
        var timeout = (this.options.timeout) ? this.options.timeout : 5000;
        this.delayStep = (this.delayStep >= Number.MAX_VALUE) ? this.delayStep : this.delayStep * 2;
        this.delayMs = Math.log(this.delayStep) * 100;
        if (test() || this.delayTotal + this.delayMs > timeout) {
            callback();
        }
        else {
            this.delayTotal += this.delayMs;
            setTimeout(function () {
                _this.backoff(test, callback);
            }, this.delayMs);
        }
    };
    /**
     * Updates existing pixels that support multiple trackers to report to the
     * specified trackers. If a pixel for the specified trackers does not exist
     * it will be created and its library will be loaded on the page unless
     * already loaded.
     */
    Pixel.prototype.addTrackers = function (trackers, useBaseCurrency) {
        var _a = groupTrackersByType(trackers), facebookTrackers = _a.facebookTrackers, globalSiteTagTrackers = _a.globalSiteTagTrackers, googleAnalyticsTrackers = _a.googleAnalyticsTrackers, googleTagManagerTrackers = _a.googleTagManagerTrackers, snapchatTrackers = _a.snapchatTrackers;
        if (facebookTrackers.length > 0) {
            if (this.fbPixel == null) {
                facebookPixel_1.default.install({ trackers: facebookTrackers });
                this.fbPixel = new facebookPixel_1.default({
                    useBaseCurrency: useBaseCurrency,
                });
            }
            else {
                // Cannot update existing pixel because Facebook does not support
                // multiple trackers.
            }
        }
        if (snapchatTrackers.length > 0) {
            if (this.snapPixel == null) {
                snapPixel_1.default.install({ trackers: snapchatTrackers });
                this.snapPixel = new snapPixel_1.default({
                    useBaseCurrency: useBaseCurrency,
                });
            }
            else {
                // Cannot update existing pixel because Snapchat does not support
                // multiple trackers.
            }
        }
        if (globalSiteTagTrackers.length > 0) {
            if (this.gtagPixel != null) {
                this.gtagPixel.addTrackers(globalSiteTagTrackers);
            }
            else {
                googleAnalyticsGtag_1.default.install({
                    trackers: globalSiteTagTrackers,
                });
                this.gtagPixel = new googleAnalyticsGtag_1.default({
                    useBaseCurrency: useBaseCurrency,
                });
            }
        }
        if (googleAnalyticsTrackers.length > 0) {
            if (this.gaPixel != null) {
                this.gaPixel.addTrackers(googleAnalyticsTrackers);
            }
            else {
                googleAnalytics_1.default.install({
                    trackers: googleAnalyticsTrackers,
                });
                this.gaPixel = new googleAnalytics_1.default({
                    useBaseCurrency: useBaseCurrency,
                    trackers: googleAnalyticsTrackers,
                });
            }
        }
        if (googleTagManagerTrackers.length > 0) {
            if (this.gtmPixel == null) {
                gtm_1.GoogleTagManager.install({
                    trackers: googleTagManagerTrackers,
                });
                this.gtmPixel = new gtm_1.GoogleTagManager({
                    useBaseCurrency: useBaseCurrency,
                });
            }
            else {
                // Unclear how multiple GTM measurement identifiers are manifested.
            }
        }
    };
    Pixel.prototype.requestReadyCallback = function (callback) {
        var events = new events_1.ChannelEventEmitter();
        if (this.readyState === ReadyState.Complete) {
            callback();
        }
        else {
            events.once('pixelReady', callback);
        }
    };
    /**
      * event
      */
    Pixel.prototype.event = function (event) {
        if (this.fbPixel) {
            this.fbPixel.event(event);
        }
        if (this.gtagPixel) {
            this.gtagPixel.event(event);
        }
        if (this.gaPixel) {
            this.gaPixel.event(event);
        }
        if (this.snapPixel) {
            this.snapPixel.event(event);
        }
        if (this.gtmPixel != null) {
            this.gtmPixel.event(event);
        }
    };
    return Pixel;
}());
exports.default = Pixel;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/Pixel.js
// module id = 606
// module chunks = 0 1